import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=8633453c&scoped=true&"
import script from "./FormPage.vue?vue&type=script&lang=js&"
export * from "./FormPage.vue?vue&type=script&lang=js&"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=8633453c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8633453c",
  null
  
)

component.options.__file = "FormPage.vue"
export default component.exports